/** Render a legend explaining colors relative to usage */
angular.module('charts')
    .directive("usageRecommendationLegend", function() {
        return {
            restrict: "E",
            templateUrl: '/resources/charts/partials/usage-recommendation-legend.html',
            controller: ['$state', '$scope', 'authentication', function($state, $scope, authentication) {
                var vm = this;

                // Capture the view level, which can be used as the label for analytic click events.
                // This allows us to understand where these click events are coming from.
                vm.viewLevel = $state.current ? $state.current.name : undefined;

                $scope.customerIsAdmin = false;
                var customerIsAdmin = authentication.getCustomer().isAdmin;
                if (customerIsAdmin !== null && customerIsAdmin) {
                  // https://dreambox.atlassian.net/browse/IN-4563 --> do not return show the below recommended usage text for admins
                  $scope.customerIsAdmin = true;
                }
            }],
            controllerAs: 'vm',
            bindToController: true
        };
    });
